import { Button, Row } from "antd";
import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableAudits from "../../components/tables/TableAudits/TableAudits";
import { useLazyFetchPaginatedAuditsQuery } from "../../features/api/apiSlice";
import { useCrudAudit } from "../../features/api/crud/hooks/useCrudAudit";
import styles from "./PageAudits.module.scss";

const PageAudits: React.FC = () => {
  const [fetchAudits, { data, isFetching }] = useLazyFetchPaginatedAuditsQuery();

  const { onDelete, isDeleting } = useCrudAudit({
    fetchAudits: () => fetchAudits(),
  });

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <div className={styles.top}>
        <h1>Les audits</h1>
        <Link to="/audits/new">
          <Button type="primary">CrÃ©er un audit</Button>
        </Link>
      </div>
      <Row>
        <TableAudits
          data={data}
          fetchData={fetchAudits}
          isLoading={isFetching || isDeleting}
          onDelete={onDelete}
        />
      </Row>
    </PageLayout>
  );
};

export default PageAudits;
